import Main from './Main'
import Mybranch from './Mybranch'

export default {
  Main, Mybranch
}



// WEBPACK FOOTER //
// ./src/components/Account/index.js